module.exports = __webpack_public_path__ + "img/Nepal.ef22f720.gif";